<script setup lang="ts">
import moment from 'moment';
import SimpleEquipStatus from './simple-equip-status.vue';
import DatePicker from '~/client/components/DatePicker.vue';
import TocCalendarUtils from '~/client/utils/TocCalendarUtils';
import { useEquipStore } from '~/store/equipStore';

const calendarUtils = new TocCalendarUtils();
import { useTocStore } from '~/store/tocStore';

const props = withDefaults(defineProps<{
  apiData: any,
  property?: any,
  isStatusTab?: boolean
  statusType?: string
  pageType?: string
}>(), {
  isStatusTab: false,
  statusType: 'all',
  pageType: 'equip'
})

const equipStore = useEquipStore();
const tocStore = useTocStore();

const emits = defineEmits(["callApi"]);

const eventData = computed(() => props.apiData);
const engSource = computed(() => tocStore.selectEquipInfo.engSource);

const selectDate = ref(moment().format("YYYY-MM-DD"));

function setDate(date: any){
  selectDate.value = date;
  
  emits("callApi", {
    startDate : date,
    endDate   : date,
  });
}

const selectType = ref('status');

</script>

<template>
  <div class="event-table common-card">
    <div class="common-card__title">
      <h2>
        이벤트 {{ props.property.statusType === 'current' ?  engSource === '20' || engSource === '30' ? '목록' : '상태' : ''  }}
      </h2>
    </div>
    <div class="content h-100">
      <div class="tab-content h-100" id="myTabContent" v-if="props.property.statusType === 'current'">
        <div 
          v-if="engSource === '10'"
          class="tab-pane fade show active h-100" 
          id="event-now-tab-pane" 
          role="tabpanel" 
          aria-labelledby="event-now-tab"
          tabindex="0" 
        >
          <div class="event-now-table row h-100">
            <!-- SECTION: 첫번째 테이블 -->
            <div class="col-4">
              <table class="table h-100">
                <thead>
                  <tr>
                    <th colspan="2">종류</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="position: relative">
                      <div class="d-flex align-items-center justify-content-center">
                        <span>
                        인버터   
                      </span>
                      <SimpleEquipStatus 
                        :eq-status="eventData.pviPowerSwitch.toLowerCase()" 
                        class="equip-status-container"
                      />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" :class="eventData.pvOverVoltage === 1 ? 'active' : ''">태양전지 과전압</td>
                  </tr>
                  <tr>
                    <td colspan="2" :class="eventData.pvLowVoltage === 1 ? 'active' : ''">태양전지 저전압</td>
                  </tr>
                  <tr>
                    <td colspan="2" :class="eventData.pvOverCurrent === 1 ? 'active' : ''">태양전지 과전류</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- SECTION: 두번째 테이블 -->
            <div class="col-4">
              <table class="table h-100">
                <colgroup>
                  <col width="40%"></col>
                  <col width="60%"></col>
                </colgroup>
                <thead>
                  <tr>
                    <th colspan="2">종류</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="2" :class="eventData.pviIGBTError === 1 ? 'active' : ''">인버터 IGBT에러</td>
                  </tr>
                  <tr>
                    <td colspan="2" :class="eventData.pviOverTemp === 1 ? 'active' : ''">인버터 과온</td>
                  </tr>
                  <tr>
                    <td colspan="2" :class="eventData.gridOverVoltage === 1 ? 'active' : ''">계통 과전압</td>
                  </tr>
                  <tr>
                    <td colspan="2" :class="eventData.gridLowVoltage === 1 ? 'active' : ''">계통 저전압</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- SECTION: 세번째 테이블 -->
            <div class="col-4">
              <table class="table no-border h-100">
                <colgroup>
                  <col width="40%"></col>
                  <col width="60%"></col>
                </colgroup>
                <thead>
                  <tr>
                    <th colspan="2">종류</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="2" :class="eventData.gridOverCurrent === 1 ? 'active' : ''">계통 과전류</td>
                  </tr>
                  <tr>
              
                    <td colspan="2" :class="eventData.gridOverFreq === 1 ? 'active' : ''">계통 과주파수</td>
                  </tr>
                  <tr>
               
                    <td colspan="2" :class="eventData.gridLowFreq === 1 ? 'active' : ''">계통 저주파수</td>
                  </tr>
                  <tr>

                    <td colspan="2" :class="eventData.islanding === 1 ? 'active' : ''">단독운전 (정전)</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- SECTION: 데이터 미수신 (12가지 조건 외 최하단 항목) -->
            <div class="col-12 data-not-received">
              <table class="table no-border">
                <tbody>
                  <tr>
                    <td :class="eventData.dataNotReceived === 1 ? 'active' : ''">
                      데이터 미수신
                      <template v-if="eventData.dataNotReceived === 1">
                        (데이터 최종 수신시간 : {{ eventData.lastReceivedDate ?? '-' }})
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div 
          v-if="engSource === '20'"
          class="tab-pane fade show active h-100" 
          id="event-now-tab-pane" 
          role="tabpanel" 
          aria-labelledby="event-now-tab"
          tabindex="0" 
        >
          <table class="table">
            <colgroup>
              <col width="15%">
              </col>
              <col width="20%">
              </col>
              <col width="20%">
              </col>
              <col width="20%">
              </col>
              <col width="25%">
              </col>
            </colgroup>
            <thead>
              <tr>
                <th>상태</th>
                <th>발생시간</th>
                <th>종료시간</th>
                <th>이벤트 상태</th>
                <th>이벤트 내용</th>
              </tr>
            </thead>
            <tbody v-if="eventData.length > 0">
              <tr v-for="(event, i) in eventData">
                <td v-if="!event.eventType.includes('rtu')">
                  <SimpleEquipStatus :eqStatus="event.opStatus"></SimpleEquipStatus>
                </td>
                <td v-else>
                  RTU 이벤트
                </td>
                <td>{{ event.eventStartDate ? moment(event.eventStartDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                <td>{{ event.eventEndDate ? moment(event.eventEndDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                <td>{{ commonUtils.isAllStrDataEmpty(event.eventCode) }}</td>
                <td>{{ isNaN(Number(event.eventCode)) ? commonUtils.isAllStrDataEmpty(event.eventCode) : commonUtils.isAllStrDataEmpty(event.fault) }}</td>
              </tr>
            </tbody>
            <tbody class="h-100" v-else>
              <tr>
                <td colspan="6">이벤트 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div 
          v-if="engSource === '30'"
          class="tab-pane fade show active h-100" 
          id="event-now-tab-pane" 
          role="tabpanel" 
          aria-labelledby="event-now-tab"
          tabindex="0" 
        >
        <template v-if="props.property.siteType === 'drgeo'">
          <table class="table">
            <colgroup>
                <col width="20%">
                </col>
                <col width="20%">
                </col>
                <col width="25%">
                </col>
                <col width="35%">
                </col>
            </colgroup>
            <thead>
              <tr>
                <th>상태</th>
                <th>설비명</th>
                <th>발생시간</th>
                <th>이벤트 내용</th>
              </tr>
            </thead>
            <tbody v-if="eventData.length > 0">
              <tr v-for="(event, i) in eventData">
                <td v-if="!event.eventType.includes('rtu')">
                  <SimpleEquipStatus :eqStatus="event.opStatus"></SimpleEquipStatus>
                </td>
                <td v-else>
                  RTU 이벤트
                </td>
                <td v-if="props.property.pageType && props.property.pageType === 'site'">{{ commonUtils.isAllStrDataEmpty(event.equipName) }}</td>
                <td>{{ event.eventStartDate ? moment(event.eventStartDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                <td>{{ isNaN(Number(event.fault)) ? commonUtils.isAllStrDataEmpty(event.fault) : commonUtils.isAllStrDataEmpty(event.eventCode) }}</td>
              </tr>
            </tbody>
            <tbody class="h-100" v-else>
              <tr>
                <td colspan="5">이벤트 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
        </template>
        <template v-else>
          <table class="table">
            <colgroup>
              <template v-if="props.property.pageType && props.property.pageType === 'site'">
                <col width="10%">
                </col>
                <col width="15%">
                </col>
                <col width="25%">
                </col>
                <col width="25%">
                </col>

                
              </template>
              <template v-else>
                <col width="15%">
                </col>
                <col width="20%">
                </col>
                <col width="20%">
                </col>
                <col width="20%">
                </col>

              </template>
            </colgroup>
            <thead>
              <tr>
                <th>상태</th>
                <th v-if="props.property.pageType && props.property.pageType === 'site'">설비명</th>
                <th>발생시간</th>
                <th>종료시간</th>
                <th>이벤트 내용</th>
              </tr>
            </thead>
            <tbody v-if="eventData.length > 0">
              <tr v-for="(event, i) in eventData">
                <td v-if="!event.eventType.includes('rtu')">
                  <SimpleEquipStatus :eqStatus="event.opStatus"></SimpleEquipStatus>
                </td>
                <td v-else>
                  RTU 이벤트
                </td>
                <td v-if="props.property.pageType && props.property.pageType === 'site'">{{ commonUtils.isAllStrDataEmpty(event.equipName) }}</td>
                <td>{{ event.eventStartDate ? moment(event.eventStartDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                <td>{{ event.eventEndDate ? moment(event.eventEndDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                <td>{{ isNaN(Number(event.eventCode)) ? commonUtils.isAllStrDataEmpty(event.eventCode) : commonUtils.isAllStrDataEmpty(event.fault) }}</td>
              </tr>
            </tbody>
            <tbody class="h-100" v-else>
              <tr>
                <td colspan="5">이벤트 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
        </template>
        </div>
      </div>
      <div v-else>
        <table class="table">
            <colgroup>
              <col width="14%">
              </col>
              <col width="19%">
              </col>
              <col width="24%">
              </col>
              <!-- <col width="20%">
              </col> -->
              <col width="19%">
              </col>
              <col width="24%">
              </col>
            </colgroup>
            <thead>
              <tr>
                <th>상태</th>
                <th>설비명</th>
                <th>발생시간</th>
                <!-- <th>종료시간</th> -->
                <th>이벤트 상태</th>
                <th>이벤트 내용</th>
              </tr>
            </thead>
            <tbody v-if="eventData.length > 0">
              <tr v-for="(event, i) in eventData">
                <td v-if="!event.eventType.includes('rtu')">
                  <SimpleEquipStatus :eqStatus="event.opStatus"></SimpleEquipStatus>
                </td>
                <td v-else>
                  RTU 이벤트
                </td>
                <td>{{ commonUtils.isAllStrDataEmpty(event.equipName) }}</td>
                <td>{{ event.eventStartDate ? moment(event.eventStartDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                <!-- <td>{{ event.eventEndDate ? moment(event.eventEndDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</td> -->
                <td>{{ commonUtils.isAllStrDataEmpty(event.eventCode) }}</td>
                <td>{{ commonUtils.isAllStrDataEmpty(event.fault) }}</td>
              </tr>
            </tbody>
            <tbody class="h-100" v-else>
              <tr>
                <td colspan="6">이벤트 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
      </div>

    </div>
  </div>

  <!-- <div class="event-table common-card">
    <div class="header">
      <div class="title">
        이벤트
      </div>
      <div class="date-tab-wrapper">
        <div class="date-select" v-if="selectType === 'history' || isStatusTab === false">
          <DatePicker
          :modelValue="selectDate"
          @setVmodel="setDate"
          >
            <template #contents>
              <div class="input-wrapper">
                <input type="text" class="calendar-icon text" :value="calendarUtils.setDateFormat(selectDate.toString())" />
                <div class="carot">
                  <img src="@/assets/images/toc/CaretDown.svg"></img>            
                </div>
              </div>
            </template>
          </DatePicker>
        </div>
        <div class="event-tab" v-if="props.isStatusTab && selectType === 'all'">
          <div class="event-tab">
            <ul class="nav nav-pills" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="event-now-tab" data-bs-toggle="tab"
                  data-bs-target="#event-now-tab-pane" type="button" role="tab" aria-controls="event-now-tab-pane"
                  aria-selected="true" @click="selectType = 'status'">상태</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="event-list-tab" data-bs-toggle="tab" data-bs-target="#event-list-tab-pane"
                  type="button" role="tab" aria-controls="event-list-tab-pane" aria-selected="false"
                  @click="selectType = 'history'"
                  >이력</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="content h-100">
      <div class="tab-content h-100" id="myTabContent" v-if="props.isStatusTab">
        <div class="tab-pane fade show active h-100" id="event-now-tab-pane" role="tabpanel" aria-labelledby="event-now-tab"
          tabindex="0">
          <div class="event-now-table row h-100">
            <div class="col-4">
              <table class="table h-100">
                <colgroup>
                  <col width="40%"></col>
                  <col width="60%"></col>
                </colgroup>
                <thead>
                  <tr>
                    <th colspan="2">종류</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <SimpleEquipStatus :eq-status="'off'" :style="{lineHeight: '10px'}"></SimpleEquipStatus>
                    </td>
                    <td>인버터 동작유무</td>
                  </tr>
                  <tr>
               
                    <td colspan="2">태양전지 과전압</td>
                  </tr>
                  <tr>
             
                    <td colspan="2">태양전지 저전압</td>
                  </tr>
                  <tr>
          
                    <td colspan="2">태양전지 과전류</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-4">
              <table class="table h-100">
                <colgroup>
                  <col width="40%"></col>
                  <col width="60%"></col>
                </colgroup>
                <thead>
                  <tr>
                    <th colspan="2">종류</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
            
                    <td colspan="2">인버터 IGBT에러</td>
                  </tr>
                  <tr>
             
                    <td colspan="2">인버터 과온</td>
                  </tr>
                  <tr>
            
                    <td colspan="2">계통 과전압</td>
                  </tr>
                  <tr>
              
                    <td colspan="2">계통 저전압</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-4">
              <table class="table h-100">
                <colgroup>
                  <col width="40%"></col>
                  <col width="60%"></col>
                </colgroup>
                <thead>
                  <tr>
                    <th colspan="2">종류</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
             
                    <td colspan="2">계통 과전류</td>
                  </tr>
                  <tr>
              
                    <td colspan="2">계통 과주파수</td>
                  </tr>
                  <tr>
               
                    <td colspan="2">계통 저주파수</td>
                  </tr>
                  <tr>
               
                    <td colspan="2">단독운전 (정전)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="event-list-tab-pane" role="tabpanel" aria-labelledby="event-list-tab"
          tabindex="0">
          <table class="table">
            <colgroup>
              <col width="10%">
              </col>
              <col width="15%">
              </col>
              <col width="20%">
              </col>
              <col width="20%">
              </col>
              <col width="15%">
              </col>
              <col width="20%">
              </col>
            </colgroup>
            <thead>
              <tr>
                <th>상태</th>
                <th>설비명</th>
                <th>발생시간</th>
                <th>종료시간</th>
                <th>이벤트 상태</th>
                <th>이벤트 내용</th>
              </tr>
            </thead>
            <tbody v-if="eventData.content.length > 0">
              <tr v-for="(event, i) in eventData.content">
                <td>
                  <SimpleEquipStatus :eqStatus="event.equipStatus"></SimpleEquipStatus>
                </td>
                <td>{{ commonUtils.isAllStrDataEmpty(event.equipName) }}</td>
                <td>{{ event.eventStartDate ? moment(event.eventStartDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                <td>{{ event.eventEndDate ? moment(event.eventEndDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                <td>{{ commonUtils.isAllStrDataEmpty(event.eventProcessStatusName) }}</td>
                <td>{{ commonUtils.isAllStrDataEmpty(event.fault) }}</td>
              </tr>
            </tbody>
            <tbody class="h-100" v-else>
              <tr>
                <td colspan="6">이벤트 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
        
      </div>
      <div v-else>
        <table class="table">
            <colgroup>
              <col width="10%">
              </col>
              <col width="15%">
              </col>
              <col width="20%">
              </col>
              <col width="20%">
              </col>
              <col width="15%">
              </col>
              <col width="20%">
              </col>
            </colgroup>
            <thead>
              <tr>
                <th>상태</th>
                <th>설비명</th>
                <th>발생시간</th>
                <th>종료시간</th>
                <th>이벤트 상태</th>
                <th>이벤트 내용</th>
              </tr>
            </thead>
            <tbody v-if="eventData.content.length > 0">
              <tr v-for="(event, i) in eventData.content">
                <td>
                  <SimpleEquipStatus :eqStatus="event.equipStatus"></SimpleEquipStatus>
                </td>
                <td>{{ commonUtils.isAllStrDataEmpty(event.equipName) }}</td>
                <td>{{ event.eventStartDate ? moment(event.eventStartDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                <td>{{ event.eventEndDate ? moment(event.eventEndDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                <td>{{ commonUtils.isAllStrDataEmpty(event.eventProcessStatusName) }}</td>
                <td>{{ commonUtils.isAllStrDataEmpty(event.fault) }}</td>
              </tr>
            </tbody>
            <tbody class="h-100" v-else>
              <tr>
                <td colspan="6">이벤트 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
      </div>

    </div>
  </div> -->
</template>

<style lang="scss" scoped>
@use "@/assets/styles/design-toc/define_font.scss";
@use "@/assets/styles/design-toc/common-card.scss";
@use "@/assets/styles/design-toc/event-table.scss";

.event-now-table{
  .table{
    tbody{
      tr{
        td{
          height: 34px;
          &.active{
            background-color: #ff0000;
            color: white;
            font-weight: bold;
          }
        }
      }
    }
  }
}

.common-card__title {
  h2 {
    min-height: unset;
  }
}

.equip-status-container {
  height: 100%;
  margin-left: 3px;
  // position: absolute;
  // top: 50%;
  // right: 70px;
  // transform: translateY(-50%);
  word-break: break-all;
  text-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: center;

  :deep(.common-label) {
    // writing-mode: vertical-lr;
    width: 50px;
    padding: 8px 4px;

    @media (max-width: 1200px) {
      padding: 8px 2px;
    }
  }
}
</style>